import i18nFactory from '@yandex-int/i18n';

import * as keyset from './TimeZoneHelper.i18n';
const i18n = i18nFactory(keyset);

export const getNameTimeZoneGroupByGroupNick = (groupNick: string): string => {
    switch (groupNick) {
        case 'world':
            return i18n('name-world-time-zone');
        case 'russia':
            return i18n('name-russia-time-zone');
        case 'cis':
            return i18n('name-cis-time-zone');
        default:
            throw new Error('Неподдерживаемый тип имени группы тайм зон');
    }
};
